// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ShopCategoriesListListResultModel from '../../model/shop-categories-list-list-result-model';
import ShopCategoriesListListResultDTO from '../dto/shop-categories-list-list-result-dto';
import dtoSchema from '../schemas/shop-categories-list-list-result-schema';
import ShopCategoriesListModel from '../../model/shop-categories-list-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class ShopCategoriesListListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ShopCategoriesListListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => ShopCategoriesListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: ShopCategoriesListModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<ShopCategoriesListListResultDTO>): ShopCategoriesListListResultModel;
  static toModel(dto: DeepPartial<ShopCategoriesListListResultDTO> | undefined | null): ShopCategoriesListListResultModel | undefined;
  static toModel(dto: DeepPartial<ShopCategoriesListListResultDTO> | undefined | null): ShopCategoriesListListResultModel | undefined {
    return dto ? new ShopCategoriesListListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ShopCategoriesListListResultModel> | ShopCategoriesListListResultModel): ShopCategoriesListListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as ShopCategoriesListListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ShopCategoriesListListResultModel, can not map to ShopCategoriesListListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
